export const START_INITIALLY_LOADING_SHOPS = 'SHOPS/START_INITIALLY_LOADING_SHOPS';

export const SHOP_BY_ID_REQUEST_START = 'SHOPS/SHOP_BY_ID_REQUEST_START';
export const SHOP_BY_ID_REQUEST_SUCCESS = 'SHOPS/SHOP_BY_ID_REQUEST_SUCCESS';
export const SHOP_BY_ID_REQUEST_FAIL = 'SHOPS/SHOP_BY_ID_REQUEST_FAIL';

export const SHOPS_REQUEST_START = 'SHOPS/SHOPS_REQUEST_START';
export const SHOPS_REQUEST_SUCCESS = 'SHOPS/SHOPS_REQUEST_SUCCESS';
export const SHOPS_REQUEST_FAIL = 'SHOPS/SHOPS_REQUEST_FAIL';

export const SHOPS_RELOAD_SHOP = 'SHOPS/SHOPS_RELOAD_SHOP';
export const SHOPS_SET_ACTIVE_SHOP_SIMPLE_CHAT = 'SHOPS/SHOPS_SET_ACTIVE_SHOP_SIMPLE_CHAT';
export const SHOPS_RELOAD_SHOP_START = 'SHOPS/SHOPS_RELOAD_SHOP_START';
export const SHOPS_RELOAD_SHOP_FAIL = 'SHOPS/SHOPS_RELOAD_SHOP_FAIL';
export const SHOPS_SELECT_SHOP = 'SHOPS/SHOPS_SELECT_SHOP';
export const SHOPS_CLEAR_DATA = 'SHOPS/SHOPS_CLEAR_DATA';

export const LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_SUCCESS = 'SHOPS/LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_SUCCESS';
export const LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_FAIL = 'SHOPS/LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_FAIL';

export const UPDATE_CURRENT_SHOP_ADMINISTRATOR = 'SHOPS/UPDATE_CURRENT_SHOP_ADMINISTRATOR';
export const UPDATE_NAME_SHOP_ADMINISTRATOR_FAIL = 'SHOPS/UPDATE_NAME_SHOP_ADMINISTRATOR_FAIL';
export const TOUCH_UPDATE_NAME_SHOP_ADMINISTRATOR_FORM = 'SHOPS/TOUCH_UPDATE_NAME_SHOP_ADMINISTRATOR_FORM';

export const startInitiallyLoadingShops = () => ({
    type: START_INITIALLY_LOADING_SHOPS,
});


export const shopByIdRequestStart = (id) => ({
    type: SHOP_BY_ID_REQUEST_START,
    id,
});

export const shopByIdRequestSuccess = (shop) => ({
    type: SHOP_BY_ID_REQUEST_SUCCESS,
    shop,
});

export const shopByIdRequestFail = (errors) => ({
    type: SHOP_BY_ID_REQUEST_FAIL,
    errors,
});


export const shopsRequestStart = (search, setRequestSending=true) => ({
    type: SHOPS_REQUEST_START,
    search,
    setRequestSending,
});

export const shopsRequestSuccess = (shops) => ({
    type: SHOPS_REQUEST_SUCCESS,
    shops,
});

export const shopsRequestFail = (errors) => ({
    type: SHOPS_REQUEST_FAIL,
    errors,
});

export const shopsReloadShop = (shop) => ({
    type: SHOPS_RELOAD_SHOP,
    shop,
});

export const shopsReloadShopStart = () => ({
    type: SHOPS_RELOAD_SHOP_START
});

export const shopsSetSimpleChat = (setTo) => ({
    type: SHOPS_SET_ACTIVE_SHOP_SIMPLE_CHAT,
    setTo
});

export const shopsReloadShopFail = () => ({
    type: SHOPS_RELOAD_SHOP_FAIL
});

export const shopsSelectShop = (shop) => ({
    type: SHOPS_SELECT_SHOP,
    shop,
});

export const shopsClearData = (errors, data = {}) => ({
    type: SHOPS_CLEAR_DATA,
    errors,
    data
});

export const loadActiveShopAdministratorsRequestSuccess = (shopAdministrators) => ({
    type: LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_SUCCESS,
    shopAdministrators,
});

export const loadActiveShopAdministratorsRequestFail = errors => ({
    type: LOAD_ACTIVE_SHOP_ADMINISTRATORS_REQUEST_FAIL,
    errors,
});

export const updateCurrentShopAdministrator = currentShopAdministrator => ({
    type: UPDATE_CURRENT_SHOP_ADMINISTRATOR,
    currentShopAdministrator,
});

export const updateNameShopAdministratorFail = errors => ({
    type: UPDATE_NAME_SHOP_ADMINISTRATOR_FAIL,
    errors
});

export const touchUpdateNameShopAdministratorForm = () => ({
    type: TOUCH_UPDATE_NAME_SHOP_ADMINISTRATOR_FORM
});
